import { useCallback } from 'react';
import { useContext } from 'react';
import CustomRouterContext from '../components/Router/RouterContext';

export const useGoBack = () => {
  const router = useContext(CustomRouterContext);

  return useCallback(() => {
    router.goBack();
  }, [router]);
};

export const useLastURL = () => {
  const router = useContext(CustomRouterContext);

  return router.lastUrl;
};
